<template>
  <div :class="stepStatus == 4 && dataDetails.isCommon==1? 'clickNone' : ''">

    <!-- ════════════════════════════════════════
         Mother
    ════════════════════════════════════════════-->
    <div class="ni-group-label">{{ $t('coll.Mother') }}</div>
    <div class="ni-card">
      <!-- Nationality -->
      <div class="ni-row" @click="showMotherPicker()">
        <span class="ni-row__label">{{ $t("coll.nationality") }}</span>
        <span class="ni-row__value" :class="[!motherCountry ? 'ni-row__value--placeholder' : '']">
          {{ motherCountry || $t('coll.choose') }}
        </span>
        <i class="ni-chevron">›</i>
      </div>

      <van-popup v-model="showMotherNationality" round position="bottom">
        <van-picker
          :title="$t('coll.choose')"
          :columns="motherColumns"
          @cancel="showMotherNationality = false"
          @confirm="onMotherConfirm"
          value-key="title"
          ref="motherPicker"
          show-toolbar
        />
      </van-popup>

      <!-- China mother -->
      <template v-if="isChinaMother">
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.legalChineseName") }}</span>
          <van-field v-model="matherData.name_cn" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>

        <div
          v-if="matherData.name_cn"
          class="ni-pinyin-banner"
          @click="fetchMotherPinyin(matherData.name_cn)"
        >
          <span class="ni-pinyin-banner__text">{{ $t("coll.pinyinBannerText") }}</span>
          <div class="ni-pinyin-banner__btn">
            <i class="ti ti-sparkles" aria-hidden="true"></i>
            {{ $t("coll.pinyinBannerBtn") }}
          </div>
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.pinyinSurname") }}</span>
          <van-field v-model="matherData.last_name" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.pinyinGivenName") }}</span>
          <van-field v-model="matherData.first_name" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.nicknameLabel") }}</span>
          <van-field v-model="matherData.nick" :placeholder="$t('coll.optionalFill')" class="ni-inline-field ni-inline-field--optional" />
        </div>
      </template>

      <!-- Non-China mother -->
      <template v-else>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.legalFirstName") }}</span>
          <van-field v-model="matherData.first_name" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.legalMiddleName") }}</span>
          <van-field v-model="matherData.middle_name" :placeholder="$t('coll.optionalFill')" class="ni-inline-field ni-inline-field--optional" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.legalLastName") }}</span>
          <van-field v-model="matherData.last_name" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.preferredName") }}</span>
          <van-field v-model="matherData.nick" :placeholder="$t('coll.optionalFill')" class="ni-inline-field ni-inline-field--optional" />
        </div>
      </template>

      <div class="ni-row ni-row--input">
        <span class="ni-row__label">{{ $t('coll.Mobile') }}</span>
        <van-field type="tel" v-model="matherData.mobile" :placeholder="$t('global.please_input')" :rules="[{ pattern, message: $t('pickupcard.invalid_phone') }]" class="ni-inline-field" />
      </div>
      <div class="ni-row ni-row--input">
        <span class="ni-row__label">{{ $t('coll.Email') }}</span>
        <van-field v-model="matherData.email" :placeholder="$t('global.please_input')" :rules="[{ email_rule, message: $t('pickupcard.invalid_email') }]" class="ni-inline-field" />
      </div>
    </div>

    <!-- ════════════════════════════════════════
         Father
    ════════════════════════════════════════════-->
    <div class="ni-group-label">{{ $t('coll.Father') }}</div>
    <div class="ni-card">
      <!-- Nationality -->
      <div class="ni-row" @click="showFatherPicker()">
        <span class="ni-row__label">{{ $t("coll.nationality") }}</span>
        <span class="ni-row__value" :class="[!fatherCountry ? 'ni-row__value--placeholder' : '']">
          {{ fatherCountry || $t('coll.choose') }}
        </span>
        <i class="ni-chevron">›</i>
      </div>

      <van-popup v-model="showFatherNationality" round position="bottom">
        <van-picker
          :title="$t('coll.choose')"
          :columns="fatherColumns"
          @cancel="showFatherNationality = false"
          @confirm="onFatherConfirm"
          value-key="title"
          ref="fatherPicker"
          show-toolbar
        />
      </van-popup>

      <!-- China father -->
      <template v-if="isChinaFather">
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.legalChineseName") }}</span>
          <van-field v-model="fatherData.name_cn" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>

        <div
          v-if="fatherData.name_cn"
          class="ni-pinyin-banner"
          @click="fetchFatherPinyin(fatherData.name_cn)"
        >
          <span class="ni-pinyin-banner__text">{{ $t("coll.pinyinBannerText") }}</span>
          <div class="ni-pinyin-banner__btn">
            <i class="ti ti-sparkles" aria-hidden="true"></i>
            {{ $t("coll.pinyinBannerBtn") }}
          </div>
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.pinyinSurname") }}</span>
          <van-field v-model="fatherData.last_name" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.pinyinGivenName") }}</span>
          <van-field v-model="fatherData.first_name" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.nicknameLabel") }}</span>
          <van-field v-model="fatherData.nick" :placeholder="$t('coll.optionalFill')" class="ni-inline-field ni-inline-field--optional" />
        </div>
      </template>

      <!-- Non-China father -->
      <template v-else>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.legalFirstName") }}</span>
          <van-field v-model="fatherData.first_name" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.legalMiddleName") }}</span>
          <van-field v-model="fatherData.middle_name" :placeholder="$t('coll.optionalFill')" class="ni-inline-field ni-inline-field--optional" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.legalLastName") }}</span>
          <van-field v-model="fatherData.last_name" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t("coll.preferredName") }}</span>
          <van-field v-model="fatherData.nick" :placeholder="$t('coll.optionalFill')" class="ni-inline-field ni-inline-field--optional" />
        </div>
      </template>

      <div class="ni-row ni-row--input">
        <span class="ni-row__label">{{ $t('coll.Mobile') }}</span>
        <van-field type="tel" v-model="fatherData.mobile" :placeholder="$t('global.please_input')" :rules="[{ pattern, message: $t('pickupcard.invalid_phone') }]" class="ni-inline-field" />
      </div>
      <div class="ni-row ni-row--input">
        <span class="ni-row__label">{{ $t('coll.Email') }}</span>
        <van-field v-model="fatherData.email" :placeholder="$t('global.please_input')" :rules="[{ email_rule, message: $t('pickupcard.invalid_email') }]" class="ni-inline-field" />
      </div>
    </div>

    <!-- ════════════════════════════════════════
         Primary contact
    ════════════════════════════════════════════-->
    <div class="ni-group-label">{{ $t("coll.please_designate_contact") }}</div>
    <div class="ni-card">
      <div class="ni-contact-select">
        <span
          class="ni-contact-option"
          :class="primary_contact.type == 1 ? 'ni-contact-option--active' : ''"
          @click="setPrimaryContact(1)"
        >{{ $t("coll.Mother") }}</span>
        <span
          class="ni-contact-option"
          :class="primary_contact.type == 2 ? 'ni-contact-option--active' : ''"
          @click="setPrimaryContact(2)"
        >{{ $t("coll.Father") }}</span>
        <span
          class="ni-contact-option"
          :class="primary_contact.type == 3 ? 'ni-contact-option--active' : ''"
          @click="setPrimaryContact(3)"
        >{{ $t("coll.otherFile") }}</span>
      </div>

      <template v-if="primary_contact.type == 3">
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t('global.name') }}</span>
          <van-field v-model="primary_contact.name" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t('coll.relationship') }}</span>
          <van-field v-model="primary_contact.relation" :placeholder="$t('global.please_input')" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t('coll.Mobile') }}</span>
          <van-field type="tel" v-model="primary_contact.mobile" :placeholder="$t('global.please_input')" :rules="[{ pattern, message: $t('pickupcard.invalid_phone') }]" class="ni-inline-field" />
        </div>
        <div class="ni-row ni-row--input">
          <span class="ni-row__label">{{ $t('coll.Email') }}</span>
          <van-field v-model="primary_contact.email" :placeholder="$t('global.please_input')" :rules="[{ email_rule, message: $t('pickupcard.invalid_email') }]" class="ni-inline-field" />
        </div>
      </template>
    </div>

    <!-- Protocol -->
    <div v-if="dataDetails.protocol.length != 0">
      <protocol-sign
        @click="baseImg"
        :busProtocol="dataDetails.protocol"
        :base64="base64"
      ></protocol-sign>
    </div>

    <!-- Submit -->
    <div class="mt-20">
      <van-button
        v-if="stepStatus == 4 && dataDetails.isCommon==1"
        disabled
        type="info"
        block
        round
        color="#4d88d2"
        class="saveSub"
      >{{ $t("coll.step_reviewed") }}</van-button>
      <a
        href="javascript:;"
        v-else
        @click="submitData()"
        class="saveBtnStep"
        :class="btnDisabled ? 'disabledSubmit' : ''"
      >{{ $t("global.submit") }}</a>
    </div>

  </div>
</template>


<!-- ============================================================
     Script — logic preserved, qiniu_token bug fixed
============================================================ -->
<script>
import Vue from "vue";
import {Toast} from "vant";
import ProtocolSign from "@/components/steps/ProtocolSign";

Vue.use(Toast);

export default {
  components: {
    "protocol-sign": ProtocolSign,
  },
  props: {
    dataDetails: {
      type: Object,
      default: () => ({ data: {}, protocol: [], qiniu_token: '', signQiniuToken: '' })
    },
    status: { type: Number, default: 0 },
    disabled: { type: Number, default: 0 },
    schoolId: { type: String }
  },
  name: "parentsInformation2",
  data() {
    return {
      parentsData: {},
      matherData: {},
      fatherData: {},
      motherCountry: "",
      fatherCountry: "",
      showMotherNationality: false,
      showFatherNationality: false,
      motherColumns: [],
      fatherColumns: [],
      parent_contact_details: [],
      primary_contact: {
        type: 0,
        name: '',
        relation: '',
        mobile: '',
        email: '',
      },
      uptoken: "",
      childid: "",
      isShow: false,
      childrenList: [],
      childIds: [],
      saveCurrent: false,
      childrenStatus: {},
      loading: true,
      emptyChild: false,
      fileinfo: null,
      pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      email_rule: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
      stepStatus: "",
      btnDisabled: false,
      base64: "",
      newSign: false,
    };
  },
  watch: {
    disabled() {
      this.btnDisabled = false;
    },
  },
  computed: {
    isChinaMother() {
      var countryId = String(this.matherData.country || '');
      return countryId === '36' || countryId === 36 || countryId === '175' || countryId === 175;
    },
    isChinaFather() {
      var countryId = String(this.fatherData.country || '');
      return countryId === '36' || countryId === 36 || countryId === '175' || countryId === 175;
    },
  },
  created() {
    this.stepStatus = this.status;
    this.parentsData = this.dataDetails.data || {};
    if (this.parentsData.minfo && Object.keys(this.parentsData.minfo).length !== 0) {
      this.matherData = this.parentsData.minfo;
    }
    if (this.parentsData.finfo && Object.keys(this.parentsData.finfo).length !== 0) {
      this.fatherData = this.parentsData.finfo;
    }
    Vue.set(this.matherData, 'country', String(this.matherData.country || ''));
    Vue.set(this.fatherData, 'country', String(this.fatherData.country || ''));
    Vue.set(this.matherData, 'name_cn', this.matherData.name_cn ? this.matherData.name_cn + "" : "");
    Vue.set(this.matherData, 'first_name', this.matherData.first_name ? this.matherData.first_name + "" : "");
    Vue.set(this.matherData, 'middle_name', this.matherData.middle_name ? this.matherData.middle_name + "" : "");
    Vue.set(this.matherData, 'last_name', this.matherData.last_name ? this.matherData.last_name + "" : "");
    Vue.set(this.matherData, 'nick', this.matherData.nick ? this.matherData.nick + "" : "");
    Vue.set(this.matherData, 'mobile', this.matherData.mobile ? this.matherData.mobile + "" : "");
    Vue.set(this.matherData, 'email', this.matherData.email ? this.matherData.email + "" : "");
    Vue.set(this.fatherData, 'name_cn', this.fatherData.name_cn ? this.fatherData.name_cn + "" : "");
    Vue.set(this.fatherData, 'first_name', this.fatherData.first_name ? this.fatherData.first_name + "" : "");
    Vue.set(this.fatherData, 'middle_name', this.fatherData.middle_name ? this.fatherData.middle_name + "" : "");
    Vue.set(this.fatherData, 'last_name', this.fatherData.last_name ? this.fatherData.last_name + "" : "");
    Vue.set(this.fatherData, 'nick', this.fatherData.nick ? this.fatherData.nick + "" : "");
    Vue.set(this.fatherData, 'mobile', this.fatherData.mobile ? this.fatherData.mobile + "" : "");
    Vue.set(this.fatherData, 'email', this.fatherData.email ? this.fatherData.email + "" : "");
    var countryList = this.dataDetails.country_list || [];
    this.motherColumns = countryList;
    this.fatherColumns = countryList;
    for (var i = 0; i < countryList.length; i++) {
      if (String(countryList[i].id) === String(this.matherData.country)) {
        this.motherCountry = countryList[i].title;
      }
      if (String(countryList[i].id) === String(this.fatherData.country)) {
        this.fatherCountry = countryList[i].title;
      }
    }
    if (this.parentsData.primary_contact && this.parentsData.primary_contact.type > 0) {
      this.primary_contact.type = this.parentsData.primary_contact.type;
      this.primary_contact.mobile = this.parentsData.primary_contact.mobile;
      this.primary_contact.name = this.parentsData.primary_contact.name;
      this.primary_contact.relation = this.parentsData.primary_contact.relation;
      this.primary_contact.email = this.parentsData.primary_contact.email;
    }
    if (this.dataDetails.sign_url != "") {
      this.base64 = this.dataDetails.sign_url;
    }
  },
  methods: {
    setPrimaryContact(primary_contact_type) {
      if (primary_contact_type == 1 && !this.matherData.mobile && !this.matherData.email) {
        Toast(this.$t('coll.please_required'));
        return;
      }
      if (primary_contact_type == 2 && !this.fatherData.mobile && !this.fatherData.email) {
        Toast(this.$t('coll.please_required'));
        return;
      }
      this.primary_contact.type = primary_contact_type;
    },
    showMotherPicker() {
      this.showMotherNationality = true;
      var that = this;
      this.$nextTick(function () {
        var index = that.lanIndexMother(that.matherData.country);
        if (index !== undefined && that.$refs.motherPicker) {
          that.$refs.motherPicker.setIndexes([index]);
        }
      });
    },
    showFatherPicker() {
      this.showFatherNationality = true;
      var that = this;
      this.$nextTick(function () {
        var index = that.lanIndexFather(that.fatherData.country);
        if (index !== undefined && that.$refs.fatherPicker) {
          that.$refs.fatherPicker.setIndexes([index]);
        }
      });
    },
    lanIndexMother(id) {
      if (!id || !this.motherColumns || this.motherColumns.length === 0) return 0;
      for (var i = 0; i < this.motherColumns.length; i++) {
        if (this.motherColumns[i].id == id) return i;
      }
      return 0;
    },
    lanIndexFather(id) {
      if (!id || !this.fatherColumns || this.fatherColumns.length === 0) return 0;
      for (var i = 0; i < this.fatherColumns.length; i++) {
        if (this.fatherColumns[i].id == id) return i;
      }
      return 0;
    },
    onMotherConfirm(value) {
      if (!value) return;
      Vue.set(this.matherData, 'country', String(value.id || ''));
      this.motherCountry = value.title || '';
      this.showMotherNationality = false;
    },
    onFatherConfirm(value) {
      if (!value) return;
      Vue.set(this.fatherData, 'country', String(value.id || ''));
      this.fatherCountry = value.title || '';
      this.showFatherNationality = false;
    },
    fetchMotherPinyin(name) {
      var that = this;
      Toast.loading({ duration: 0, forbidClick: true, message: that.$t('coll.fetchingPinyin') });
      Vue.axios({ url: '/api/collection/namePinyin', method: 'post', data: { name: name } })
        .then(function (res) {
          Toast.clear();
          var data = Array.isArray(res) ? res : res.data;
          if (Array.isArray(data) && data.length >= 2) {
            Vue.set(that.matherData, 'last_name', data[0] || '');
            Vue.set(that.matherData, 'first_name', data[1] || '');
          } else {
            Toast(that.$t('coll.pinyinFailed'));
          }
        })
        .catch(function () {
          Toast.clear();
          Toast(that.$t('coll.pinyinFailed'));
        });
    },
    fetchFatherPinyin(name) {
      var that = this;
      Toast.loading({ duration: 0, forbidClick: true, message: that.$t('coll.fetchingPinyin') });
      Vue.axios({ url: '/api/collection/namePinyin', method: 'post', data: { name: name } })
        .then(function (res) {
          Toast.clear();
          var data = Array.isArray(res) ? res : res.data;
          if (Array.isArray(data) && data.length >= 2) {
            Vue.set(that.fatherData, 'last_name', data[0] || '');
            Vue.set(that.fatherData, 'first_name', data[1] || '');
          } else {
            Toast(that.$t('coll.pinyinFailed'));
          }
        })
        .catch(function () {
          Toast.clear();
          Toast(that.$t('coll.pinyinFailed'));
        });
    },
    baseImg(data) {
      if (data != "cancel") {
        this.base64 = data;
        this.newSign = true;
      }
    },
    phoneValidate(params) {
      if (this.pattern.test(params.trim())) {
        return true;
      } else {
        return false;
      }
    },
    emailValidate(params) {
      if (this.email_rule.test(params.trim())) {
        return true;
      } else {
        return false;
      }
    },
    submitData() {
      let that = this;
      if (this.btnDisabled) return;
      if (Object.keys(this.matherData).length == 0 && Object.keys(this.fatherData).length == 0) {
        Toast(this.$t('coll.please_required'));
        return;
      }
      let m = {
        "id": that.matherData.id,
        "country": that.matherData.country || '',
        "name_cn": that.matherData.name_cn ? that.matherData.name_cn.trim() : '',
        "first_name": that.matherData.first_name ? that.matherData.first_name.trim() : '',
        "middle_name": that.matherData.middle_name ? that.matherData.middle_name.trim() : '',
        "last_name": that.matherData.last_name ? that.matherData.last_name.trim() : '',
        "nick": that.matherData.nick ? that.matherData.nick.trim() : '',
        "email": that.matherData.email ? that.matherData.email.trim() : '',
        "mobile": that.matherData.mobile ? that.matherData.mobile.trim() : '',
      };
      let f = {
        "id": that.fatherData.id,
        "country": that.fatherData.country || '',
        "name_cn": that.fatherData.name_cn ? that.fatherData.name_cn.trim() : '',
        "first_name": that.fatherData.first_name ? that.fatherData.first_name.trim() : '',
        "middle_name": that.fatherData.middle_name ? that.fatherData.middle_name.trim() : '',
        "last_name": that.fatherData.last_name ? that.fatherData.last_name.trim() : '',
        "nick": that.fatherData.nick ? that.fatherData.nick.trim() : '',
        "email": that.fatherData.email ? that.fatherData.email.trim() : '',
        "mobile": that.fatherData.mobile ? that.fatherData.mobile.trim() : ''
      };
      if (m.last_name == '' && m.first_name == '' && m.email == '' && m.mobile == '' && f.last_name == '' && f.first_name == '' && f.email == '' && f.mobile == '') {
        Toast(this.$t('coll.please_required'));
        return;
      }
      let m_f = [m, f];
      for (let index in m_f) {
        let item = m_f[index];
        let parent = index == 0 ? this.$t('coll.Mother') : this.$t('coll.Father');
        if (item.mobile) {
          that.parent_contact_details.push(item.mobile);
        }
        if (item.email) {
          that.parent_contact_details.push(item.email);
        }
        var hasParentData = item.email || item.mobile || item.last_name || item.first_name || item.middle_name || item.nick || item.name_cn;
        if (hasParentData && (!item.country || item.country == '')) {
          Toast(parent + this.$t("coll.please_select_nationality"));
          return;
        }
        if (!item.id && hasParentData) {
          if (!item.last_name || item.last_name == '') {
            Toast(parent + ' last_name null');
            return;
          }
          if (!item.first_name || item.first_name == '') {
            Toast(parent + ' first_name null');
            return;
          }
          if (!item.mobile || item.mobile == '' || !this.phoneValidate(item.mobile)) {
            Toast(parent + this.$t("pickupcard.invalid_phone"));
            return;
          }
        }
        if (item.id && (item.email || !item.mobile)) {
          if (item.mobile) {
            if (!this.phoneValidate(item.mobile)) {
              Toast(parent + this.$t("pickupcard.invalid_phone"));
              return;
            }
          }
        }
      }
      if (this.fatherData.email == '' && this.matherData.email == '') {
        Toast(this.$t("pickupcard.invalid_email"));
        return;
      }
      if (this.fatherData.email && this.fatherData.email != '' && !this.emailValidate(this.fatherData.email)) {
        Toast(this.$t("pickupcard.invalid_email"));
        return;
      }
      if (this.matherData.email && this.matherData.email != '' && !this.emailValidate(this.matherData.email)) {
        Toast(this.$t("pickupcard.invalid_email"));
        return;
      }
      if (this.fatherData.email && this.matherData.email && this.fatherData.email.trim() == this.matherData.email.trim()) {
        Toast(this.$t('coll.not_duplicate'));
        return;
      }
      if (this.fatherData.mobile && this.matherData.mobile && this.fatherData.mobile.trim() == this.matherData.mobile.trim()) {
        Toast(this.$t('coll.not_duplicate'));
        return;
      }
      if (that.primary_contact.type == 1 && !this.matherData.mobile && !this.matherData.email) {
        this.primary_contact.type = 0;
        Toast(this.$t('coll.please_required'));
        return;
      }
      if (that.primary_contact.type == 2 && !this.fatherData.mobile && !this.fatherData.email) {
        this.primary_contact.type = 0;
        Toast(this.$t('coll.please_required'));
        return;
      }
      if (that.primary_contact.type == 3) {
        if (that.primary_contact.name.trim() == '' || that.primary_contact.relation == '') {
          Toast(this.$t('coll.please_required'));
          return;
        }
        if (that.primary_contact.mobile == '' || !this.phoneValidate(that.primary_contact.mobile)) {
          Toast(this.$t('pickupcard.invalid_phone'));
          return;
        }
        if (that.primary_contact.email == '' || !this.emailValidate(that.primary_contact.email)) {
          Toast(this.$t('pickupcard.invalid_email'));
          return;
        }
      }
      if (that.dataDetails.protocol.length != 0 && this.base64 == "") {
        Toast(that.$t("coll.please_sign"));
        return;
      }
      if (that.dataDetails.protocol.length == 0) {
        that.saveData();
        return;
      }
      if (!that.newSign) {
        that.saveData();
        return;
      }
      this.$nextTick(function () {
        this.btnDisabled = true;
      });

      var pic = this.base64.substring(this.base64.indexOf(",") + 1);
      var url = "https://upload-z1.qiniup.com/putb64/-1";
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          var resJson = JSON.parse(xhr.responseText);
          if (resJson.code == 0) {
            Vue.set(that.parentsData, "sign_url", resJson.data.url);
            Vue.set(that.parentsData, "sign", resJson.data.key);
            that.saveData();
          } else {
            Toast(resJson.msg);
            that.btnDisabled = false;
          }
        }
      };
      xhr.open("POST", url, true);
      xhr.setRequestHeader("Content-Type", "application/octet-stream");
      xhr.setRequestHeader("Authorization", "UpToken " + that.dataDetails.signQiniuToken);
      xhr.send(pic);
    },
    saveData() {
      let dats = {
        finfo: this.fatherData,
        minfo: this.matherData,
        primary_contact: this.primary_contact,
        sign: this.parentsData.sign,
        sign_url: this.parentsData.sign_url,
      };
      this.btnDisabled = true;
      this.$emit("change", dats);
    },
  },
};
</script>


<style lang="less" scoped>
/* ── Group labels ── */
.ni-group-label {
  font-size: 11px;
  font-weight: 500;
  color: #888780;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 18px 0 6px 2px;
}

/* ── Cards ── */
.ni-card {
  background: #f7f8f9;
  border-radius: 12px;
  border: 0.5px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* ── Rows ── */
.ni-row {
  display: flex;
  align-items: center;
  padding: 0 14px;
  min-height: 48px;
  gap: 8px;
  cursor: pointer;
}
.ni-row + .ni-row {
  border-top: 0.5px solid rgba(0, 0, 0, 0.06);
}
.ni-row--input {
  cursor: default;
  padding-right: 10px;
}
.ni-row__label {
  font-size: 13px;
  color: #888780;
  width: 130px;
  flex-shrink: 0;
}
.ni-row__value {
  font-size: 14px;
  color: #2c2c2a;
  flex: 1;
  text-align: right;
}
.ni-row__value--placeholder {
  color: #b4b2a9;
}
/* ── Chevron ── */
.ni-chevron {
  font-size: 18px;
  color: #b4b2a9;
  line-height: 1;
}

/* ── Inline van-field ── */
.ni-inline-field {
  flex: 1;
  padding: 0 !important;
  background: transparent !important;

  /deep/ .van-field__control {
    font-size: 14px;
    color: #2c2c2a;
    text-align: right;
  }
  /deep/ .van-field__control::placeholder {
    color: #b4b2a9;
    font-size: 13px;
  }
  /deep/ .van-cell {
    padding: 0;
    background: transparent;
  }
}

/* ── Primary contact select ── */
.ni-contact-select {
  display: flex;
  gap: 10px;
  padding: 14px;
}
.ni-contact-option {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #646566;
  padding: 8px 0;
  border-radius: 8px;
  background: #ffffff;
  border: 0.5px solid rgba(0, 0, 0, 0.12);
  cursor: pointer;
}
.ni-contact-option--active {
  color: #1a6fe8;
  background: #eef4fd;
  border-color: #b5d4f4;
}

/* ── Pinyin banner ── */
.ni-pinyin-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 9px 14px;
  background: #E6F1FB;
  border-top: 0.5px solid #B5D4F4;
  border-bottom: 0.5px solid #B5D4F4;
  cursor: pointer;
}
.ni-pinyin-banner__text {
  font-size: 12px;
  color: #185fa5;
}
.ni-pinyin-banner__btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #0C447C;
  background: #fff;
  border: 0.5px solid #85B7EB;
  border-radius: 20px;
  padding: 4px 12px;
  flex-shrink: 0;
}
.ni-pinyin-banner__btn i {
  font-size: 13px;
}
</style>
